<template>
  <div class="detail">
    <div class="header">
      <div class="title">获取区域内设施</div>
      <div class="extra" @click="cancel">
        <a-icon type="close" />
      </div>
    </div>

    <div class="body">
        <div class="status-info">
            <div class="status-dot"></div>
            <span>{{message}}</span>
        </div>
      <div style="padding-top: 1em"></div>
      <a-radio-group v-model="selected">
        <a-radio value="矩形">矩形</a-radio>
        <a-radio value="圆形">圆形</a-radio>
        <a-radio value="多边形">多边形</a-radio>
      </a-radio-group>

      <div class="center">
          <button class="btn btn-secondary" @click="clear">清除</button>
          <button class="btn btn-primary" @click="query" type="primary">查询设备</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    overlays: {
      type: Array,
      default: () => [],
    },
    mouseTool: {},
  },
  data() {
    return {
      selected: null,
    };
  },

  computed: {
    message() {
      if (this.selected === "矩形" || this.selected === "圆形") {
        return "请用鼠标在地图上左键按住一个位置开始拖动";
      } else if (this.selected === "多边形") {
        return "请点击地图任意位置，结束多边形绘制，请点击鼠标右键";
      } else {
        return "选择图形";
      }
    },
  },

  watch: {
    selected() {
      if (this.selected === "矩形") {
        this.mouseTool?.rectangle({
          fillColor: "#00b0ff",
          strokeColor: "#80d8ff",
          //同Polygon的Option设置
        });
      } else if (this.selected === "圆形") {
        this.mouseTool?.circle({
          fillColor: "#00b0ff",
          strokeColor: "#80d8ff",
          //同Circle的Option设置
        });
      } else if (this.selected === "多边形") {
        this.mouseTool?.polygon({
          fillColor: "#00b0ff",
          strokeColor: "#80d8ff",
          //同Polygon的Option设置
        });
      }
    },
  },

  methods: {
    cancel() {
      this.selected = null;
      this.$emit("cancel");
    },
    clear() {
      // this.selected = null;
      this.$emit("clear");
    },
      query() {
          const list = [];

          this.overlays.forEach((item) => {
              let coordinates = null;
              if (typeof item.getPosition === 'function') {
                  const position = item.getPosition();
                  coordinates = [position.lng, position.lat];
              } else if (typeof item.getPath === 'function') {
                  coordinates = item.getPath();
              } else if (item._opts && item._opts.path) {
                  coordinates = item._opts.path;
              }

              if (coordinates) {
                  if (Array.isArray(coordinates) && coordinates.length === 2) {
                      const [lng, lat] = coordinates;
                      if (!isNaN(lng) && !isNaN(lat)) {
                          list.push([Number(lng), Number(lat)]);
                      }
                  }
                  else if (Array.isArray(coordinates) && Array.isArray(coordinates[0])) {
                      const validPath = coordinates.filter(([lng, lat]) =>
                          !isNaN(lng) && !isNaN(lat)
                      ).map(([lng, lat]) => [Number(lng), Number(lat)]);
                      if (validPath.length > 0) {
                          list.push(validPath);
                      }
                  }
              }
          });

          this.$emit("query", list);
      },
    // query() {
    //       const list = [];
    //
    //       // if (this.overlays[0] && this.overlays[0]._position) {
    //       //   list.push(
    //       //     this.overlays.map((item) => {
    //       //       return [item._position.lng, item._position.lat];
    //       //     })
    //       //   );
    //       // }
    //
    //       this.overlays.forEach((item) => {
    //           if (Array.isArray(item.aE) && item.aE[0]) {
    //               list.push(item.aE[0]);
    //           }
    //
    //           if (item._opts && item._opts.path) {
    //               list.push(item._opts.path);
    //           }
    //       });
    //
    //       this.$emit("query", list);
    //   },
  },
};
</script>


<style lang="less" scoped>
.detail {
  position: fixed;
  top: 11vh;
  right: calc(1vw + 140px);
  z-index: 99;
  background-color: var(--detail-bgcolor);
  width: 20vw;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #073d3c;
  & > .header {
    background-color: var(--default-bgcolor);
    color: #00ff96;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .body {
    padding: 1em;
    .center {
      margin-top: 2em;
    }
  }

  .status-info {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #d5d5d5;
    font-size: 0.9rem;
    border: 1px dashed #255f47;
    padding:1rem;
    border-radius: 10px;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    background: #00ff96;
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(0, 255, 150, 0.5); }
    70% { box-shadow: 0 0 0 10px rgba(0, 255, 150, 0); }
    100% { box-shadow: 0 0 0 0 rgba(0, 255, 150, 0); }
  }
}
::v-deep .ant-radio-wrapper{
  color: #b9b9b9;
}

.btn-secondary {
  background: rgba(20, 35, 70, 0.5);
  border: 1px solid rgba(0, 255, 150, 0.3);
  color: #00ff96;
  coursor: pointer;
}
.btn-secondary:hover {
  background: rgba(0, 255, 150, 0.1);
}
.btn-primary {
  background: linear-gradient(135deg, #00ff96, #00d4ff);
  color: #0a0e27;
  font-weight: 600;
  coursor: pointer;
}
.btn-primary:hover {
  box-shadow: 0 0 10px 0 rgba(0, 255, 150, 0.5);
}
.btn {
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 25px;
}
</style>